export default __webpack_public_path__ + "static/media/icon-calendar.ff3480a8.svg";